/* Aloha Palms - adjusts the "Customize or personalize your order" checkout pop-up to the cart:
   - asks "Are you giving this as a gift?" when the cart is gifts/keepsakes only
   - hides food-only add-ons (topper, cheese lettering, board/cake add-on links) when the cart has no food item
   - prices premium gift wrapping by what it wraps */
(function () {
  var FOOD_HANDLES = [
    'classic-charcuterie-board-best-seller', 'hand-delivered-charcuterie-board-nut-free',
    'hand-delivered-charcuterie-board-vegan', 'hand-delivered-charcuterie-board-gluten-free',
    'custom-charcuterie-board-multiple-dietary-restrictions-accommodated', 'charcuterie-platter-board-or-box',
    'heart-shaped-charcuterie-board', 'fresh-fruit-platters', 'fresh-fruit-cakes',
    'classic-christmas-holiday-boards', 'christmas-tree-board-bundle', '3d-christmas-tree-cone',
    'thanksgiving-charcuterie-boards-pre-order', 'halloween-spooktacular-charcuterie-boards',
    'baby-shower-oh-baby-baptism-charcuterie-board', 'limited-edition-valentine-s-heart-charcuterie-board',
    'letter-number-celebration-boards', 'rainbow-in-a-cup-individually-packed-charcuterie-cup',
    'full-service-grazing-table-catering-oahu-hawaii-aloha-palms-hospitality'
  ];

  function setHidden(el, hide) {
    if (!el) return;
    el.style.display = hide ? 'none' : '';
    if (hide) {
      el.querySelectorAll('input[type=checkbox]').forEach(function (cb) {
        if (cb.checked) { cb.checked = false; cb.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    }
  }

  // Premium gift wrapping is priced by what it wraps: fruit cakes $20; boards by size ($10 / $15 / $20); keepsakes $10.
  var WRAP_SMALL = 'Premium Gift Wrapping';
  var WRAP_LARGE = 'Premium Gift Wrapping - Island Feast or Luau Extravaganza';
  var WRAP_XXL = 'Premium Gift Wrapping - Grand Taste of Aloha';
  var WRAP_CAKE = 'Premium Gift Wrapping - Fruit Cake';
  var WRAP_RANK = {}; WRAP_RANK[WRAP_SMALL] = 1; WRAP_RANK[WRAP_LARGE] = 2; WRAP_RANK[WRAP_XXL] = 3; WRAP_RANK[WRAP_CAKE] = 3;

  function wrapFor(item) {
    var t = (item.variant_title || '') + ' ' + (item.title || '');
    if (item.handle === 'fresh-fruit-cakes') return WRAP_CAKE;
    if (/grand taste/i.test(t)) return WRAP_XXL;
    if (/island feast|luau extravaganza/i.test(t)) return WRAP_LARGE;
    return WRAP_SMALL;
  }

  function setWrap(modal, cart) {
    var cb = modal.querySelector('[data-apo-v^="Premium Gift Wrapping"]');
    if (!cb) return;
    var choice = WRAP_SMALL;
    (cart.items || []).forEach(function (i) {
      var w = wrapFor(i);
      if (WRAP_RANK[w] > WRAP_RANK[choice] || (w === WRAP_CAKE && WRAP_RANK[choice] === 3)) choice = w;
    });
    var data = {};
    try { data = JSON.parse(document.getElementById('apo-data').textContent).variants || {}; } catch (e) {}
    if (!data[choice]) choice = WRAP_SMALL;
    cb.setAttribute('data-apo-v', choice);
    var em = cb.parentNode.querySelector('em');
    if (em && data[choice]) { em.setAttribute('data-apo-p', choice); em.textContent = '+' + data[choice].price; }
  }

  function adjust(modal) {
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      var hasFood = (cart.items || []).some(function (i) { return FOOD_HANDLES.indexOf(i.handle) !== -1; });
      var gift = document.getElementById('apo-gift');
      var giftLabel = gift && gift.parentNode.querySelector('span');
      if (giftLabel) giftLabel.textContent = hasFood ? 'This is a gift or celebration' : 'Are you giving this as a gift?';

      var topper = document.getElementById('apo-topper');
      setHidden(topper && topper.closest('label'), !hasFood);
      if (!hasFood) { var sel = document.getElementById('apo-topper-design'); if (sel) sel.hidden = true; }
      var cheese = modal.querySelector('[data-apo-v="Cheese Lettering"]');
      setHidden(cheese && cheese.closest('label'), !hasFood);
      if (!hasFood) { var ct = document.getElementById('apo-cheese-text'); if (ct) ct.hidden = true; }
      setHidden(modal.querySelector('.apo__more'), !hasFood);
      setWrap(modal, cart);
    }).catch(function () {});
  }

  function init() {
    var modal = document.getElementById('apo-modal');
    if (!modal) return;
    new MutationObserver(function () {
      if (modal.classList.contains('is-open')) adjust(modal);
    }).observe(modal, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
